<script setup lang="ts">
    import TextInput from '@/components/TextInput.vue';
    import ImageInput from '@/components/ImageInput.vue';
    import { computed } from 'vue';
    import type { IField } from '@/typescript/interfaces/IField';
    import type { ITextField } from '@/typescript/interfaces/ITextField';
    import type { IImageField } from '@/typescript/interfaces/IImageField';

    const { field } = defineProps<{ field: IField }>();

    const isTextField = computed(() => 'defaultText' in field);
</script>
<template>
    <TextInput
        v-if="isTextField"
        :field="field as ITextField"
    />
    <ImageInput
        v-else
        :field="field as IImageField"
    />
</template>
